import Vue from 'vue'
import { Notify } from 'quasar'
import { padEnd } from 'lodash'

Vue.prototype.$can = function (permission) {
  if (this.$page.props.auth.roles.indexOf('super amdin') !== -1) {
    return true
  }
  for (let p of permission.split('|')) {
    if (this.$page.props.auth.permissions.indexOf(p) !== -1) {
      return true
    }
  }
  return false
}

Vue.prototype.$trimTrailingZero = function (val, pad = false) {
  if (val === null || val === 0) {
    return val
  }

  let [start, end] = val.split('.')
  end = end.replace(/0+$/, '')

  if (pad) {
    end = padEnd(end, pad, '0')
  }

  return [start, end].join('.').replace(/\.$/, '')
}

Vue.prototype.$saveFile = function (r) {
  let file = r.headers['content-disposition'].split('=')[1].replace(/"/g, '')
  saveAs(r.data, file)
}

Vue.prototype.$errorSimple = function (errors) {
  Notify.create({
    type: 'negative',
    message: [...Object.values(errors)].join(', '),
    position: 'top',
  })
}

Vue.prototype.$errorMore = function (errors, child) {
  child.notify = child.$q.notify({
    type: 'negative',
    message: [...Object.values(errors)].join('<br>'),
    html: true,
    position: 'top-right',
    multiLine: true,
    timeout: 0,
    actions: [
      { label: 'Dismiss', color: 'white', handler: () => { child.notify = null } }
    ],
  })
}

Vue.prototype.$submit = function (api) {
  this.loading = true
  let method = 'post'
  if (this.selected !== null) {
    method = 'put'
    api += `/${this.selected.id}`
  }
  this.$inertia[method](api, this.form, {
    onSuccess: () => {
      this.show = false
      this.resetForm()
    },
    onError: this.$errorSimple,
    onFinish: () => this.loading = false
  })
}

Vue.prototype.$submitExtra = function (api) {
  if (this.notify) {
    this.notify()
  }

  this.loading = true
  let method = 'post'
  if (this.selected !== null) {
    method = 'put'
    api += `/${this.selected.id}`
  }
  this.$inertia[method](api, this.form, {
    onSuccess: () => {
      this.show = false
      this.resetForm()
    },
    onError: (errors) => this.$errorMore(errors, this),
    onFinish: () => this.loading = false
  })
}

Vue.prototype.$selectEdit = function (row) {
  this.selected = row
  this.show = true
}

Vue.prototype.$selectDelete = function (row, api, message = null) {
  this.$q.dialog({
    title: 'Confirm Delete',
    message: message ? message : row.name,
    cancel: true,
    ok: {
      color: 'red',
      flat: true
    },
    cancel: {
      color: 'grey',
      flat: true
    }
  }).onOk(() => this.$inertia.delete(`${api}/${row.id}`))
}

Vue.prototype.$visibleColumns = function (can = null) {
  let visibleColumns = this.columns.map(c => c.name)
  let i = visibleColumns.indexOf('actions')
  if (can && this.$can(can) === false && i !== -1) {
    visibleColumns.splice(i, 1)
  }

  return visibleColumns
}
